/* eslint-disable prettier/prettier */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';

import {  getCatalogosT, getInformacionInicial, CreateSolicitud} from 'store/solicitudes/solicitudesActions'
import { LogInPublico } from 'store/login/loginSlice'

import VerticalTabs from './tabs'
import { Container } from '@mui/material';
import PageLayout from "examples/LayoutContainers/PageLayout";
function SolicitudPublica() {

    const dispatch = useDispatch();
    useEffect(() => {
      const iniciar = async () => {
        const respuesta = await dispatch(LogInPublico("publico","Des@rrollo1"));          // 1. Obtienes el token
         if(respuesta.code === "Ok"){
             getInformacionInicial(dispatch, false);  // 2. Se lo pasas
             getCatalogosT(dispatch);                // 3. También aquí
          }else{
            alert("Datos de acceso incorrectos");
          }
       
      };
      iniciar();
    }, []);


  return <>
  <PageLayout >
    <Container>
        <VerticalTabs  CrearSolicitud={(data)=>{
          CreateSolicitud(dispatch,data);
        }}/>
        <Toaster
        toastOptions={{ style: { backgroundColor: "#5873B8", fontSize: 12, color: "white" } }}
      />
    </Container>
  </PageLayout>
        
      


   
    
  </>
}

export default SolicitudPublica;
